import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from 'src/providers/authservices/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'formbeneficios',
    loadChildren: () => import('./formbeneficios/formbeneficios.module').then( m => m.FormLjPageModule)
  },
  {
    path: 'formbeneficios/listagem',
    loadChildren: () => import('./formbeneficios-listagem/formbeneficios-listagem.module').then( m => m.FormBeneficiosListagemModule), canActivate: [AuthGuardService]
  },
  {
    path: 'formbeneficios/listagem/:id',
    loadChildren: () => import('./formbeneficios/formbeneficios.module').then( m => m.FormLjPageModule), canActivate: [AuthGuardService]
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'config',
    loadChildren: () => import('./configbiometria/config.module').then( m => m.ConfigPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'comunicacao',
    loadChildren: () => import('./communication/communication.module').then( m => m.CommunicationPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'autorizacao',
    loadChildren: () => import('./authorization/authorization.module').then( m => m.AuthorizationPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'informe',
    loadChildren: () => import('./report/report.module').then( m => m.ReportPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./users/users.module').then( m => m.UsersPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'listacolaboradores',
    loadChildren: () => import('./components-modal/listacolaboradores/listacolaboradores.module').then( m => m.ListacolaboradoresPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'criardepartamento',
    loadChildren: () => import('./components-modal/criardepartamento/criardepartamento.module').then( m => m.CriardepartamentoPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'createdocumento',
    loadChildren: () => import('./components-modal/criardocumento/createdocumento.module').then( m => m.CreatedocumentoPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'createprestacao',
    loadChildren: () => import('./components-modal/criarprestacao/createprestacao.module').then( m => m.CreatePrestacaoPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'criarservico',
    loadChildren: () => import('./components-modal/criarservico/criarservico.module').then( m => m.CriarservicoPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'shoppings',
    loadChildren: () => import('./shops/shops.module').then( m => m.ShopsPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'cobranca',
    loadChildren: () => import('./charge/charge.module').then( m => m.ChargePageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'wiki',
    loadChildren: () => import('./wiki/wiki.module').then( m => m.WikiPageModule)
  },
  {
    path: 'password',
    loadChildren: () => import('./password/password.module').then( m => m.PasswordPageModule)
  },
  {
    path: 'reset-password.html', redirectTo: 'password', pathMatch: 'full'
  },
  {
    path: 'addperfil',
    loadChildren: () => import('./components-modal/addperfil/addperfil.module').then( m => m.AddperfilPageModule)
  },
  {
    path: 'createautorizacaoservico',
    loadChildren: () => import('./components-modal/createautorizacaoservico/createautorizacaoservico.module').then( m => m.CreateautorizacaoservicoModule)
  },
  {
    path: 'createcomunicado',
    loadChildren: () => import('./components-modal/createcomunicado/createcomunicado.module').then( m => m.CreatecomunicadoPageModule)
  },
  {
    path: 'createiacomunicacao',
    loadChildren: () => import('./components-modal/criarprompt/createprompt.module').then( m => m.CreatepromptPageModule)
  },
  {
    path: 'createnotificacao',
    loadChildren: () => import('./components-modal/createnotificacao/createnotificacao.module').then( m => m.CreatenotificacaoPageModule)
  },
  {
    path: 'escolherempresacontrato',
    loadChildren: () => import('./components-modal/escolherempresacontrato/escolherempresacontrato.module').then( m => m.EscolherempresacontratoPageModule)
  },
  {
    path: 'criartipodocumento',
    loadChildren: () => import('./components-modal/criartipodocumento/criartipodocumento.module').then( m => m.CriartipodocumentoPageModule)
  },
  {
    path: 'addusermultiplan',
    loadChildren: () => import('./components-modal/addusermultiplan/addusermultiplan.module').then( m => m.AddusermultiplanPageModule)
  },
  {
    path: 'searchSelector',
    loadChildren: () => import('./components-modal/select-searchable/select-searchable.module').then( m => m.SelectSearchablePageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'modalcontroleciente',
    loadChildren: () => import('./components-modal/controleciente/controleciente.module').then( m => m.ControleCientePageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'searchSelectorApi',
    loadChildren: () => import('./components-modal/select-searchable-api/select-searchable.module').then( m => m.SelectSearchablePageApiModule),canActivate: [AuthGuardService]
  },
  {
    path: 'searchSelectorGeneric',
    loadChildren: () => import('./components-modal/select-searchable-users/select-searchable-users.module').then( m => m.SelectSearchableUsersComponentModule),canActivate: [AuthGuardService]
  },
  {
    path: 'timelineread',
    loadChildren: () => import('./components-modal/message/timelineread/timelineread.module').then( m => m.TimelinereadPageModule)
  },
  {
    path: 'biblioteca',
    loadChildren: () => import('./library/library.module').then( m => m.LibraryPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'iacomunicacao',
    loadChildren: () => import('./iacomunicacao/iacomunicacao.module').then( m => m.IaComunicacaoPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'dashboard-multi',
    loadChildren: () => import('./dashboard-multi/dashboard-multi.module').then( m => m.DashboardMultiPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'auditoria',
    loadChildren: () => import('./audit/audit.module').then( m => m.AuditPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'audit-detail',
    loadChildren: () => import('./components-modal/audit-detail/audit-detail.module').then( m => m.AuditDetailPageModule)
  },
  { path: 'config/banners',
    loadChildren: () => import('./config/banners/banners.module').then( m => m.BannersPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'config/modais',
    loadChildren: () => import('./config/modals/modals.module').then( m => m.ModalsPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'config/encomendas',
    loadChildren: () => import('./config/encomendas/encomendas.module').then( m => m.EncomendasPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'createbanner',
    loadChildren: () => import('./config/banners/createbanner/createbanner.module').then( m => m.CreatebannerPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'createmodal',
    loadChildren: () => import('./config/modals/createmodal/createmodal.module').then( m => m.CreatemodalPageModule),canActivate: [AuthGuardService]
  },
  {
    path: 'modal-template',
    loadChildren: () => import('./config/modals/modal-template/modal-template.module').then( m => m.ModalTemplatePageModule)
  },
  {
    path: 'modal-auditoria',
    loadChildren: () => import('./config/modals/modal-auditoria/modal-auditoria.module').then( m => m.ModalAuditoriaPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
